module.exports = __webpack_public_path__ + "static/patreon-logo-a11b0cf51129be66a51c1fcce7596991.jpg";